import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
	providedIn: 'root'
})
export class LoadingService {
	loading: HTMLIonLoadingElement = null;
	constructor(private loadingController: LoadingController) {}

	async show(loading: boolean = true) {
		if (loading && !this.loading) {
			this.loading = await this.loadingController.create({
				spinner: 'crescent',
				mode: 'md',
				cssClass: 'custom-loading'
			});
			await this.loading.present();
		}
	}

	hide(refresher?: any, infiniteScroll?: any) {
		if (this.loading) {
			this.loading.dismiss();
			this.loading = null;
		}

		if (refresher) {
			try {
				refresher.target.complete();
			} catch {}
		}
		if (infiniteScroll) {
			infiniteScroll.target.complete();
		}
	}
}
